import React, { Component } from 'react';
import { connect } from 'react-redux';
import {isEmpty} from 'lodash'
import {Grid} from '@material-ui/core'
import CheckBoxInputUtokning from '../Inputs/CheckBoxInputUtokning'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({accountsData,auth}) {
    const { Utokning,CurrentObjekt } = accountsData
    const { authUser } = auth;
    return {
        Utokning,authUser,CurrentObjekt
    };
}

function mapDispatchToProps(dispatch) {
    return {

    };
}

class index extends Component {
    state={
        Mstate:this.props.Mstate
    }
    render() {
        return (
            <>
                {
                    isEmpty(this.props.Utokning)?"":
                    <Grid
                    container
                    direction="row"
                    alignItems="center"
                    >
                        <Grid item xs={12} className={"p-1"}><IntlMessages id="Free.Inputs"/></Grid>
                        <Grid item xs={12} className={"p-1"}>
                        <CheckBoxInputUtokning Meta="Fria fält" disabled={false} Value={false} 
                        onChangeMstate={this.props.onChangeMstate} 
                        Mstate={this.props.Mstate}/>
                        </Grid>
                       
                    </Grid>
                }
            </>
        );
    }
}

export default connect(
    mapStateToProps,
)(index);